import { Text } from "lucide-react";

import { SECTION_TYPES } from "@/lib/constants/sections";

import type { ServiceSection } from "@/types/sections";

const textSection: ServiceSection = {
  type: SECTION_TYPES.TEXT,
  content: {
    header: "Your message here",
    subheader: "We're a team of professionals who are passionate about what we do.",
  },
  meta: {
    displayName: "Text",
    displayDescription: "Use styled text to emphasize a message",
    displayIcon: Text,
    variantsCount: 2,
  },
};

export default textSection;
